import { max } from 'date-fns';

export const getAverage = (arr: number[]) =>
  arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0;

export const getMaxDate = (dates: Date[]): Date | undefined => {
  return dates.length > 0 ? max(dates) : undefined;
};
